<template>
  <div class="header">
    <div class="header_box w1200">
      <div class="lt">
        <ul>
          <li :class="num==1?'on':''" @click="toIndex(1)">全部</li>
          <!-- <li :class="num==2?'on':''" @click="toIndex(2)">社区、社群电商</li>
          <li :class="num==3?'on':''" @click="toIndex(3)">本地生活</li>
          <li :class="num==4?'on':''" @click="toIndex(4)">到家服务</li> -->
          <li :class="num==item.index?'on':''" v-for="item in product_classify" :key="item.index" @click="toIndex(item.index)">{{item.title}}</li>
        </ul>
      </div>
      <div class="rt">
        <div class="rtitem" @click="toUsercenter">
          <img src="../public/images/icon01.png" alt />
          <!-- <router-link to="/user_center">个人中心</router-link> -->
          <span>个人中心</span>
        </div>
        <div class="rtitem" @click="loginOut">
          <img src="../public/images/icon02.png" alt />
          <span>退出登录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { productList } from '../public/js/api.js'
  export default {
    name: "Header",
    data() {
      return {
        num: 1,
        product_classify: []
      };
    },
    // props: {
    //   productClassify: {
    //     type:Array,
    //     default:()=>[]
    //   }
    // },
    methods: {
      changeStatus(n) {
        this.num = n;
        this.$emit("changeStatus", n);
      },
      toIndex(n) {
        this.num = n;
        this.$router.push({
          path: `/index?status=${n}`
        });
        this.$emit("changeStatus", n);
      },
      async loginOut() {
        try {
          await this.$alert("是否退出登录", "提示", {
            showCancelButton: true,
            cancelButtonText: "取消",
            type: "warning"
          })
          localStorage.setItem('JBR_SAAS_TOKEN', '')
          location.href = './login.html'
        } catch (err) {}
      },
      toUsercenter() {
        let token = localStorage.getItem('JBR_SAAS_TOKEN')
        if (token) {
          this.$router.push('/user_center')
        } else {
          location.href = './login.html'
        }
      },
      async getlist(){
        let res = await productList()
        console.log(res)
        if(res.code != 1){
          this.$message.error(res.msg)
          return
        }
        let product_classify = res.data.product_list.map((item,index)=>{
          return {index:index+2,title:item.one_class_title}
        })
        this.product_classify = product_classify
      },
    },
    created(){
      this.getlist()
    },
    mounted() {
      let num = this.$route.query.status;
      this.num = num ? num : 1;
      this.$emit("changeStatus", num);
      console.log("status", this.num);
    }
  };
</script>

<style lang="scss">
  .container {
    background-color: #f9f9f9;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    overflow-y: auto;
    padding-bottom: 120px;
    box-sizing: border-box;
  }

  .header {
    height: 80px;
    background-color: #fff;

    .header_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
    }

    .lt {
      ul {
        font-size: 16px;
        color: #333;
        display: flex;

        li {
          margin-right: 60px;
          cursor: pointer;
          position: relative;
        }

        .on {
          color: #ff5543;
        }

        .on::after {
          content: "";
          width: 100%;
          height: 3px;
          background-color: #ff5543;
          position: absolute;
          left: 0;
          bottom: -10px;
        }
      }
    }

    .rt {
      display: flex;
      align-items: center;

      .rtitem {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #666;
        margin-left: 38px;

        a {
          color: #666;
        }

        img {
          width: 14px;
          margin-right: 7px;
        }

        span {
          cursor: pointer;
        }
      }
    }
  }
</style>